import React, { memo } from 'react'
import { Avatar } from '@mui/material'

// CustomAvatar component can be used to display user's avatar with their first name and last name initials
// It accepts the following props:
// - src: string, the URL of the image to be displayed
// - user: object, the user object containing the first_name and last_name properties
function CustomAvatar ({ src, user, size, fontSize, className, style }) {
    const colors = (string="") => {
      let hash = 0;
      for (let i = 0; i < string.length; i++) {
          hash = string.charCodeAt(i) + ((hash << 5) - hash);
      }
      let color = '#';
      for (let i = 0; i < 3; i++) {
          const value = (hash >> (i * 8)) & 0xff;
          color += ('00' + value.toString(16)).slice(-2);
      }
      return color;
  };
    return (
      <Avatar
        className={className}
        style={style}
        alt={`${user?.first_name} ${user?.last_name}`.toUpperCase()}
        src={src || " "}
        sx={{
            fontSize: fontSize || 14,
            width: size || "40px",
            height: size || "40px",
            bgcolor: colors(user?.first_name),
        }}
      />
    )
  }

export default memo(CustomAvatar)